<template>
    <ldc-dialog
        :title="title"
        :colorTitle="colorTitle"
        :clickoutside="true"
        width="50%"
        :fullscreen="$detect == 'mobile'"
        :class="{
            'product-dialog' : true,
            'modal-register-vip': $detect == 'web',
            'modal-mobile-vip position-relative': $detect == 'mobile',
            'modal-HappyLink' : action == 'add',
            'modal-dght' : action == 'edit',
            'modal-normal' : action == 'auto',
        }"
        :visible.sync="dialog">
        <div class="content-modal py-3 px-10px">
            <div class="d-flex mt-3">
                <div :class="{
                            'w-30' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">
                        <span class="text-danger mr-1">*</span>Tên nhóm:
                    </div>  
                </div>
                <div class="w-70">
                    <div class="value">
                         <input :class="{
                                'm_input' : true,
                                'border-primary' : ucg_name != ''
                            }" type="text" id="inputTitle" placeholder="Tên nhóm danh mục" 
                             v-model="ucg_name" />
                    </div>
                    <div class="text-danger fs-12px mt-1" v-if="error.ucg_name">{{error.ucg_name}}</div>
                </div>
            </div>
            <div class="d-flex mt-3">
                <div :class="{
                            'w-30' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name"><span class="text-danger mr-1">*</span>Thứ tự:</div>
                </div>
                <div class="w-70">
                    <div class="value">
                       <input type="text" class="m_input mr-1 text-right"
                            v-model="ucg_order" ref="input-action-dialog" @input="maxAmount()"
                            @focus="(e) => e.target.select()"/>
                    </div>
                    <div class="text-danger fs-12px mt-1" v-if="error.ucg_order">{{error.ucg_order}}</div>
                </div>
            </div>
             <div class="d-flex mt-3">
                <div :class="{
                            'w-30' : true,
                            'fw-600' :  $detect == 'mobile'
                        }">
                    <div class="name">Tùy chọn:</div>
                </div>
                <div class="w-70">
                    <input type="checkbox" id="show_child" class="mr-1"  value="hide_link" v-model="checkedNames">
                    <label for="show_child">Không có link</label><br>
                    <input type="checkbox" id="hide" class="mr-1"  value="hide" v-model="checkedNames">
                    <label for="hide">Không hiển thị trên menu trái</label><br>
                </div>
            </div>
        </div>
        <div class="footer-modal text-center">
            <button :class="{
                    'btn btn-confirm my-10px mr-10px': true,
                    'btn-sm': $detect == 'web'
                }"
                :disabled="loading"
                @click="submit()"
                >Xác nhận</button>
        </div>
    </ldc-dialog>
</template>
<script>
export default {
    props: ['visible', 'data', 'action', 'multiple', 'dataMultiple', 'arrGroup'],
    data() {
        return {
            dialog: false,
            title: '',
            oneManipulation: {},
            colorTitle: '',
            amount: '',
            actionMuti: false,
            total: 0,
            loading: false,
            source_pay: this.$detect == 'web' ? 0: 1,
            max_amount : 0,
            checkDataLink : false,

            arrEdit : [],
            ucg_name : '',
            checkedNames : [],
            files : [],
            fileUploaded: [],
            ucg_order : 1,
            ucg_hide_link : 0,
            ucg_hide  : 0,
            cat_parent : 0,
            parent_id: 0,
            arrCategory : [],
            show_cat : false,
            arrActiveCat : [],
            error : [],
        }
    },
    watch: {
        cat_parent(val){
            this.getCategory();
            this.show_cat = true;
        },
        visible(val){
            this.dialog = val;
            
        },
        dialog(val){
            this.error = [];
            this.$emit('update:visible', val);
            
        },
        action(val){
            if(val == 'add'){
                this.title = 'Thêm mới danh mục';
                this.colorTitle = '#dc3545';
                this.getListCategory();
            }else if(val == 'edit'){
                this.title = 'Sửa danh mục';
                this.oneManipulation = this.config.con_raovat_super_vip_price;
                this.colorTitle = '#20c997';
            }else if(val == 'auto'){
                this.title = 'Up tự động';
                this.oneManipulation = this.config.con_raovat_up_price;
                this.colorTitle = '#0c81f6';
            }
        },
        data(){
            if(this.action == 'edit'){
                this.checkedNames = [];
                this.getDataCategoryUserGroup();
            }
        },
        checkedNames(val){
            this.ucg_hide = 0;
            this.ucg_hide_link = 0;
            val.map(item => {
                if(item == 'hide_link'){
                    this.ucg_hide_link = 1
                }
                if(item == 'hide'){
                    this.ucg_hide = 1
                }
            });
        },
        amount(newVal, oldVal) {
            if(newVal * 1 == newVal && newVal % 1 == 0){
                if(newVal <= 1000){
                    if(this.actionMuti){

                    }else{
                        this.singleAction();
                    }
                }else{
                    this.amount = 1000;
                }
            }else{
                this.amount = oldVal;
            }
        }
    },
    created (){

    },
    mounted(){

    },
    computed: {
        config(){
            return this.$store.state.config;
        },
        money(){
            return this.$store.state.money;
        },
    },
    methods: {
        undo(){
            this.parent_id = 0;
            this.getCategory();
        },
        GetCat(val){
            this.parent_id = val.id;
            this.getCategory();
        },
        async addCat(val){    
            await apiPost('v2/profile/products/add_user_category_group', {
                record_id : this.data.id ? this.data.id : 0,
                ucg_name : this.ucg_name,
                ucg_order : this.ucg_order,
                ucg_hide : this.ucg_hide,
                ucg_hide_link : this.ucg_hide_link,
                action : this.action
            }).then(res => {
                this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                this.dialog = false;
                this.loading = false;
            }).catch(err => {
                this.error = err.data.error;
                // if(err.status == 410){
                //     this.$message({
                //         message: err.data.message,
                //         type: 'error',
                //         center: true,
                //     });
                    
                //  }
            })
        },
        getCategory(){
            apiGet('v2/category', {
                module: 'product',
                parent_id: this.parent_id,
            }).then(res => {
                this.arrCategory = res
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        del(){apiPost('/v2/products/add_happy_link', {
                iPro: this.data.id,
                action     : 'delete'
            }).then(res => {
                console.log(res)
                this.$message({
                    message: res.message,
                    type: 'success',
                    center: true,
                });
                this.visible = false;
                this.loading = false;
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        maxAmount(){
            this.max_amount = this.$formatNumber(this.max_amount)
        },
        getListCategory(){
            apiGet('v2/profile/products/get_list_user_category').then(res => {
               this.arrActiveCat  = res.data;

            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        getDataCategoryUserGroup(){
            apiGet('v2/profile/products/get_data_user_category_group', {
                record_id: this.data.id,
            }).then(res => {
                this.ucg_name = res.data.ucg_name;
                this.ucg_order = res.data.ucg_order;
                this.ucg_hide  = res.data.ucg_hide;
                this.ucg_hide_link = res.data.ucg_hide_link;
                if(res.data.ucg_hide == 1) this.checkedNames.push('hide');
                if(res.data.ucg_hide_link == 1) this.checkedNames.push('hide_link');
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
        singleAction(){
            if(!this.multiple){
                this.total = this.amount * this.oneManipulation.money;
            }else{
                this.total = this.amount * this.oneManipulation.money * this.dataMultiple.length;
            }
        },
        submit(){
            this.addCat(this.data);
        },
        async edit(){
            this.loading = true;
            let idReturn = null;
            await apiPut('/v2/products/edit_user_category', {
                uc_category_id  : this.data.iCat,
                uc_group_id : this.uc_group_id,
                uc_order    : this.uc_order,
                uc_homepage :  this.uc_homepage,
                uc_homepage_icon    : this.uc_homepage_icon,
                uc_show_child   : this.uc_show_child,
                uc_hide : this.uc_hide,
                files : this.fileUploaded,
                record_id : this.data.iCat,
            }).then(res => {
                this.$message({
                    message: res.message,
                    type: 'success',
                    center: true,
                });
                this.dialog = false;
                this.loading = false;
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    
                 }
            })
        },
    }
}
</script>
<style lang="scss">
.m-0-auto{
    margin: 0 auto;
}
.n-cat{
    padding-top: 10px;
}
.bor-top{
    border-top: 1px solid #e5e5e5;
}
.select-mobile-post{
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    .ion-md-arrow-dropdown{
        float: right;
    }
}
.modal-mobile-vip{
    &.modal-HappyLink{
        .title-dialog{
            background : #dc3545;
        }
    }
    &.modal-dght{
        .title-dialog{
            background : #20c997;
        }
    }
}
.title-cat{
    margin-bottom: 0;
    color: #007bff;
}
.undo-icon{
    font-size: 19px;
    color: #007bff;

}
.add-icon{
    color : #20c997;
}
.image-icon{
    width : 42px;
    height : 42px;
}
.incate{
    font-size : 11px;
    color: #dc3545;
}
.w-100px{
    width : 100px;
}
.w-155{
    width : 155px !important;
}
.modal-mobile-vip{
    .content-modal{
        margin-top : 0;
    }
    &.modal-HappyLink {
        .footer-modal{
            .btn-confirm, .btn-danger{
                width: 40%;
            }
        }
    }
}
    .modal-register-vip, .modal-mobile-vip{
        &.modal-HappyLink{
            .title-dialog {
                border-bottom: 1px solid #dc3545;
            }
            .footer-modal{
                border-top: 1px solid #dc3545;
                .btn-confirm{
                    color: white;
                    background : #dc3545;
                }
            }
        }
        &.modal-dght {
            .title-dialog {
                border-bottom: 1px solid #20c997;
            }
            .footer-modal{
                border-top: 1px solid #20c997;
                .btn-confirm{
                    color: white;
                    background : #20c997;
                }
            }
        }
    }
    .product-dialog{
        .content-change-time{
            .date-change{
                height: 35px;
                border-radius: 4px;
                border: 1px solid rgba(0, 0, 0, 0.2);
                color: #606266;
                outline: none;
                cursor: pointer;
            }
        }

        .content-modal{
            .value{
                .select-dght{
                    height: 35px;
                    border-radius: 4px;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    color: #606266;
                    outline: none;
                    cursor: pointer;
                    width: 155px;
                }
                .input-link{
                    width: 95.5%;
                }
                .border-none{
                    border : unset;
                }
                .input-price-vip{
                    width: 155px;
                    color : #dc3545;
                }
                .span-happy-link{
                    border: unset;
                }
            } 
        }
    }
    .m_input{
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        height: 40px;
        line-height: 40px;
        outline: none;
        padding: 0 15px;
        width : 100%;
    }
</style>
